import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from 'src/app/controls/advanced-gridview/services/advanced-service';
import { CrudFormComponent } from 'src/app/controls/crud-form/crud-form.component';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { Group } from 'src/app/models/group';
import { IUser } from 'src/app/models/interfaces/user.interface';
import { GroupsService } from 'src/app/services/groups.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { RolesService } from 'src/app/services/roles.service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';
@Component({
    selector: 'app-group-parent-form',
    templateUrl: '../../../controls/crud-form/crud-form.component.html',
    styleUrls: ['../../../controls/crud-form/crud-form.component.scss'],
    imports: [AdvancedGridviewComponent, MatButtonModule, FileUploadModule, NgxSpinnerModule],
})
export class GroupParentFormComponent extends CrudFormComponent<Group, IUser, null> {
    public constructor(
        private groupsService: GroupsService,
        private rolesService: RolesService,
        public override enumHelper: EnumHelper,
        protected override notificationService: NotificationService,
        protected override spinner: NgxSpinnerService,
        public override dialog: MatDialog,
        public override memoryService: MemoryService
    ) {
        super(enumHelper, notificationService, spinner, dialog, memoryService);
    }

    /**
     * Définition des colonnes de la Gridview.
     */
    override get defaultTableConfig(): ColumnDefinition[] {
        return [
            new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 40, true),
            new ColumnListDefinition<Group>('roles', 'Rôles', FilterType.List, 3, 55, true, false),
        ];
    }

    /**
     * Définition des colonnes de la Gridview.
     */
    override get withIdTableConfig(): ColumnDefinition[] {
        return [
            new ColumnDefinition('id', 'Id', ColumnType.Text, FilterType.Text, 1, 18, true),
            new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 37, true),
            new ColumnListDefinition<Group>('roles', 'Rôles', FilterType.List, 3, 40, true, false),
        ];
    }

    /**
     * Charge les éléments des filtres d'une colonnes de type liste.
     * @param datasourceContext
     * @param columns
     */
    protected override loadListColumnDatas(datasourceContext: Context, columns: ColumnListDefinition<string>[]): void {
        this.rolesService.ListAttributable().subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>(
                (v) =>
                    <ListItem<string>>{
                        value: v.id.toString(),
                        text: `${v.getDisplayName()}`,
                    }
            );
            this.setColumnFilterDatas(
                columns.find((x) => x.columnName === 'roles'),
                listItem
            );
        });
    }

    /**
     * Retourne la source de données de la liste.
     */
    protected override getDatasourceService(): AdvancedService<Group> {
        return this.groupsService;
    }

    /**
     * Retourne le contexte utilisé par la source de données de la liste.
     */
    protected override getDatasourceContext(): Context {
        return { property: 'userParentsId', value: this._context.item.id };
    }

    /**
     * Retourne les infos de tri par défaut de la liste.
     */
    protected override getDefaultSortInfos(): SortInfos {
        return new SortInfos('name', 'asc');
    }

    /**
     * Retourne le droit necessaire pour pouvoir crééer un enregistrement.
     */
    public override getCreationRight(): Rights {
        return Rights.GroupAndUserCreate;
    }

    /**
     * Retourne le droit necessaire pour pouvoir mettre à jour un enregistrement.
     */
    protected override getUpdateRight(): Rights {
        return Rights.GroupAndUserEdit;
    }

    /**
     * Retourne le droit necessaire pour pouvoir supprimer un enregistrement.
     */
    protected override getDeletionRight(): Rights {
        return Rights.GroupAndUserDelete;
    }

    /**
     * Retourne une valeur indiquant si la colonne Action est visible.
     * @returns False pour indiquer que la colonne action n'est pas visible.
     */
    public override isActionColumnVisible() {
        return false;
    }
}
